import axios from 'axios';
import Env from '~/env';
import { LocalStorage } from '~/storage/LocalStorage';
import { INSURANCE_AUTO_AUTH_KEY } from '~/storage/constants';
import { getInsuranceAutoTokenUseCase } from '~/useCases/AssegurouAutoUseCases/GetTokenAutoUseCase';
const ASSEGUROU_URL = Env.INSURANCE_AUTO_URL;

const apiAssegurouAuto = axios.create({
  baseURL: `${ASSEGUROU_URL}`,
});

apiAssegurouAuto.interceptors.request.use(async (config) => {
  const token = await getInsuranceAutoTokenUseCase();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  ``;

  return config;
});

apiAssegurouAuto.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      await LocalStorage.remove(INSURANCE_AUTO_AUTH_KEY);
      return apiAssegurouAuto.request(error.config);
    }

    return Promise.reject(error);
  }
);

export default apiAssegurouAuto;
